import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NewsletterSubscriptionInitialState, NewsletterSubscribeConfirmation } from './newsletter-subscription.actions';
import { NewsletterSubscriptionState, NewsletterSubscriptionStateModel } from './newsletter-subscription.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';

@Injectable({ providedIn: 'root' })
export class NewsletterSubscriptionFacade implements LoadDataFacade, SetInitialStateFacade {
  newsletterData$: Observable<NewsletterSubscriptionStateModel> = this.store.select(
    NewsletterSubscriptionState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(NewsletterSubscriptionState.getLoaded);

  constructor(private store: Store) {}

  loadAll(token: string): void {
    this.store.dispatch(new NewsletterSubscribeConfirmation(token));
  }

  setInitialState(): void {
    this.store.dispatch(new NewsletterSubscriptionInitialState());
  }
}
